import { useEffect } from "react";

const useExecFunctionOnBackButton = (callback) => {
    useEffect(() => {
        let shouldHandleEvent = true;
        let timeoutId = undefined;
        const handleEvent = (event) => {
            event.preventDefault();
            if (shouldHandleEvent) {
                shouldHandleEvent = false;
                //handleCallback.current();
                callback();
            }
            else {
                shouldHandleEvent = true;
            }
        };

        // Timeout added due to event listener was attaching before event fires.
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => window.addEventListener("popstate", handleEvent), 350);

        return () => {
            // Timeout added due to event listener was being removed before function was called.
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => window.removeEventListener("popstate", handleEvent), 350);
        };
    }, [callback]);
}

export default useExecFunctionOnBackButton;